import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AhctUtils } from 'src/app/core/services/AhctUtils';
import { AsstntsrchServiceService } from 'src/app/services/AsstntsrchService';
import { ResponseObject } from 'src/app/model/ResponseObject';
import * as _ from 'lodash';
import { ConfirmAssistance } from 'src/app/model/ConfirmAssistance';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AppRouteConstants } from 'src/app/core/constants/AppRouteConstants';
import { SharedService } from 'src/app/services/shared.service';

import { ManageMyAssistanceR2RModel } from 'src/app/model/ManageMyAssistanceR2RModel';
import { ManageMyASTSCService } from 'src/app/services/ManageMyASTSCService';

@Component({
  selector: 'app-confirm-asstnt',
  templateUrl: './confirm-asstnt.component.html',
  styleUrls: ['./confirm-asstnt.component.css']
})
export class ConfirmAsstntComponent implements OnInit {

  name:string;
  phoneNumber:string;
  assistId:string;
  confirmAssistance :ConfirmAssistance=new ConfirmAssistance();
  showConfDialog:boolean=false;

  manageMyAssistanceR2RModel: ManageMyAssistanceR2RModel = new ManageMyAssistanceR2RModel();
  existingAssisterReln: string;
  existingAssisterId: string;
  
  constructor(private _router: Router, private _sharedService: SharedService, private ahctUtils: AhctUtils,private _asstntSrchService : AsstntsrchServiceService,private modalService: NgbModal, private manageMyASTSCService: ManageMyASTSCService) { }
  
  ngOnInit() {

    this._sharedService.publicBreadCrumbFlagChange(true);
    this._sharedService.publicNonEnrollFlow(false);
    this._sharedService.publicAnonFlowChanges(false);


    //this._sharedService.publicNonEnrollFlow(false);
    this.assistId=localStorage.getItem('assisterId');
    this._asstntSrchService.getAssistConfirmInfo(this.assistId).subscribe(
      res => {
        const resp: ResponseObject = _.clone(res);
        if(resp.nextPath == "SUCCESS"){
          this.confirmAssistance=resp.object;
          this.name=this.confirmAssistance.lastName+', '+this.confirmAssistance.firstName;
          localStorage.setItem('name',this.confirmAssistance.lastName+','+this.confirmAssistance.firstName);
       }
        

  });
  }
  
  submitHandler()
  {
    this.showConfDialog=true;
  
  }

  onSubmitNext()
  {
    //R43 PT-17304 Start
    this.manageMyASTSCService.loadManageMyASTSC_RM().subscribe(
      res => {
        this.manageMyAssistanceR2RModel = _.clone(res);
        if (this.manageMyAssistanceR2RModel != null) {
          this.existingAssisterId =  this.manageMyAssistanceR2RModel.assisterId;
          this.existingAssisterReln = this.manageMyAssistanceR2RModel.assRelCd;
          if (this.assistId != this.existingAssisterId){
            this.manageMyASTSCService.declineAssistance(this.manageMyAssistanceR2RModel).subscribe(
              res => {
                this.manageMyAssistanceR2RModel = _.clone(res);
                if(this.manageMyAssistanceR2RModel.nextPath=='SUCCESS')
                {
                  this._router.navigateByUrl("/"+AppRouteConstants.AST_SRCH_PRFX_MDUL+"/assistSearchPostConfirm");
                  alert('successfully replaced');
                }
              }
            )
          }
        }
        console.log(this.existingAssisterId, this.existingAssisterReln);
        //R43 PT-17304 End
      });
      
    
    this._router.navigateByUrl("/"+AppRouteConstants.AST_SRCH_PRFX_MDUL+"/assistSearchPostConfirm");
  }
  

  closeConfDialog(event){
    if(event==true) {
      this.showConfDialog = false;
      this.onSubmitNext();
    } else {
      this.showConfDialog = false;
    }
  }

  backButtonAction()
  {
    localStorage.setItem('backFromAstConfirm','YES');
    this._router.navigateByUrl("/"+AppRouteConstants.AST_SRCH_PRFX_MDUL+"/assistSearchActConfirm");
  }

  ngOnDestroy() {
    this._sharedService.publicNonEnrollFlow(true);
  }

}
